import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {humanFileSize} from "~/helpers/utils";
import {DownloadIcon, FileIcon} from "~/Components/Icons/Icons";
import {Modal} from "react-bootstrap";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import { ExclamationMarkCircleIcon } from '../../Components/Icons/Icons';

const MyDocuments = ({invitation, isMobile = false}) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const exists = invitation.itinerary && invitation.itinerary.document;

    if (exists) {
        return (
            <>
                <hr className="d-none d-lg-block" />
                <div className="itinerary">
                    <label><TextTranslate name="word-your-documents" fallback="Your documents"/></label>
                    {invitation.itinerary.document && (
                        <div className="single_file">
                            <div className="mr-2">
                                <div className="d-flex justify-content-between">
                                    <FileIcon classes="d-inline mr-1" />
                                    {invitation.itinerary.document.name} <small>{humanFileSize(invitation.itinerary.document.size)}</small>
                                </div>
                            </div>
                            <div>
                                <a href={invitation.itinerary.document.download_url}><DownloadIcon/></a>
                            </div>
                        </div>
                    )}

                </div>
            </>
        )
    }

    return (
        <>
            <hr className="d-none d-lg-block" />
            <div className="settings__item">
                <div>
                    <label><TextTranslate name="word-your-documents" fallback="Your documents"/></label>
                    <p className="font-weight-500">
                        <TextTranslate name="word-itinerary-not-available" fallback="Your itinerary is not available yet"/>.
                    </p>
                </div>
                <div className="text-right">
                    {isMobile ?
                        <a onClick={handleShow} className="btn btn-icon-only p-0">
                            <ExclamationMarkCircleIcon />
                        </a>
                        :
                        <a onClick={handleShow} className="link text-primary cursor-pointer">
                            <TextTranslate name="word-read-more" fallback="Read More"/>
                        </a>
                    }
                </div>
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title><TextTranslate name="modal-event-itinerary" fallback="Event Itinerary" textOnly/></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        <TextTranslate name="modal-event-itinerary-msg" textOnly/>
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Link to='/contact' className="btn btn-primary btn-x">
                        <TextTranslate name="word-contact-us" fallback="Contact Us" textOnly/>
                    </Link>
                </Modal.Footer>
            </Modal>
        </>
    );
};


export default MyDocuments;
